import { render, staticRenderFns } from "./Pictures.vue?vue&type=template&id=5b65b4f3&scoped=true"
import script from "./Pictures.vue?vue&type=script&lang=js"
export * from "./Pictures.vue?vue&type=script&lang=js"
import style0 from "./Pictures.vue?vue&type=style&index=0&id=5b65b4f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65b4f3",
  null
  
)

export default component.exports